// User provisioning status badge component
// Used in Organization Users management

const STATUS_CONFIG = {
  pending: {
    bg: 'bg-slate-100',
    text: 'text-slate-600',
    label: 'Pending'
  },
  provisioning: {
    bg: 'bg-amber-100',
    text: 'text-amber-700',
    label: 'Provisioning'
  },
  completed: {
    bg: 'bg-green-100',
    text: 'text-green-700',
    label: 'Completed'
  },
  failed: {
    bg: 'bg-red-100',
    text: 'text-red-700',
    label: 'Failed'
  }
}

const UserStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      {status === 'provisioning' && (
        <svg className="animate-spin -ml-0.5 mr-1 h-3 w-3" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      )}
      {status === 'completed' && (
        <svg className="-ml-0.5 mr-1 h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      )}
      {status === 'failed' && (
        <svg className="-ml-0.5 mr-1 h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      )}
      {config.label}
    </span>
  )
}

export default UserStatusBadge
